requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xBadges', {
      loadingEl: new Set(),
      fixedPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container pointer-events-none{container-img-class} ltr"
        {preview-show-condition}
      >
        {content}
      </div>`,
      customPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full pointer-events-none{container-css-class} ltr"
        x-data="{
          contentHeight: 1,
          rePosition() {
            this.$nextTick(() => {
              this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
            });
          }
        }"
        x-intersect.once="rePosition();
          if (Shopify.designMode) {
            window.addEventListener('resize', () => {
              if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                rePosition();
              }
            });
          } else {
            installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
          }"
        {preview-show-condition}
        :style="'{css-position} min-height: ' + contentHeight + 'px'"
      >
        {content}
      </div>`,
      productDetailTemplate: `
      {teleport-template-open}
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-css-class}{container-img-class}"
          style="{css-position}"
          x-data="{
            contentHeight: 1,
            rePosition() {
              this.$nextTick(() => {
                this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
              });
            }
          }"
          x-intersect.once="rePosition();
            if (Shopify.designMode) {
              window.addEventListener('resize', () => {
                if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                  rePosition();
                }
              });
            } else {
              installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
            }"
        >
          {content}
        </div>
      {teleport-template-close}
      `,
      outSideImageTemplate: `<div class="hidden" 
        x-data="{
          setPosition() {
            const element = $el.closest('.card-product').getElementsByClassName('{queryEL}');
            for (let i = 0; i < element.length; i++) {
              element[i].innerHTML += $el.innerHTML;
            }
          }
        }"
        x-init="setPosition()">
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-img-class}"
          {preview-show-condition}
        >
          {content}
        </div>
      </div>`,
      previewActiveBlock: window.xBadgesPreviewActiveBlock,
      init() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (!event.target.classList.contains('x-badges-block-preview')) return;

            let blockId = event.target.getAttribute('block-id');
            this.previewActiveBlock = blockId;
            window.xBadgesPreviewActiveBlock = blockId;
            document.dispatchEvent(new CustomEvent("eurus:badges:block-select"));
          });
        }
      },
      load(el, callback = () => {}, container = null, productCard = false, isByob = false) {
        if (this.loadingEl.has(el)) return;
        this.loadingEl.add(el);
        if (container) el.container = container;

        const sliderEl = el.closest('[x-data-slider]');
        if (sliderEl) {
          if (!sliderEl.classList.contains('is-initialized')) {
            if (isByob) {
              this.doLoad(el, productCard, callback);
            }
            const sectionId = el.closest('[x-data-slider]').getAttribute('x-data-slider');
            document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
              this.doLoad(el, productCard, callback);
            }, { once: true });
          } else {
            this.doLoad(el, productCard, callback);
          }
        } else {
          this.doLoad(el, productCard, callback);
        }
        this.loadingEl.delete(el);
      },
      doLoad(el, productCard, callback = () => {}) {
        this.initAllLabels(el, productCard);

        if (Shopify.designMode) {
          let productData = xParseJSON(el.getAttribute('x-labels-data'));
          document.addEventListener('shopify:section:load', () => {
            if (productData && !productData.isXBadgesPreview) {
              this.initAllLabels(el, productCard);
            }
          });
        }

        callback(el);
      },
      isCardFixedOverlayPosition(position) {
        return position !== 'custom'
          && position !== 'below-image'
          && position !== 'bottom-card'
          && position !== 'next-price';
      },
      getCardBadgeMountEl(el) {
        const cardProduct = el.closest('.card-product');
        if (!cardProduct) return el;
        const anchor = el.tagName === 'A' ? el : el.closest('a');
        if (!anchor) return el;
        const parent = anchor.parentElement;
        if (parent && [...parent.classList].some((cls) => cls.includes('relative'))) {
          return parent;
        }
        const relativeWrapper = anchor.closest('.relative');
        return relativeWrapper || parent || el;
      },
      collectCardBadgeItems(cardProduct) {
        const items = [];
        cardProduct.querySelectorAll('.label-container .x-badge-content, .custom-label-container .x-badge-content').forEach((node) => {
          if (node.closest('.below-image') || node.closest('.x-card-badges-a11y')) return;
          const text = node.textContent.trim();
          if (text) {
            items.push({ text, html: node.outerHTML });
          }
        });
        return items;
      },
      getCardBadgeMountElFromProduct(cardProduct) {
        const anchor = cardProduct.querySelector('a.link-product-variant.x-labels-data, a.x-labels-data.link-product-variant, a.link-product-variant');
        if (!anchor) return null;
        return this.getCardBadgeMountEl(anchor);
      },
      finalizeCardBadgeAccessibility(cardProduct, badgeItems) {
        cardProduct.querySelectorAll('.x-card-badges-a11y').forEach((node) => node.remove());

        const mountEl = this.getCardBadgeMountElFromProduct(cardProduct);
        const anchor = mountEl?.querySelector('a.link-product-variant, a.x-labels-data, a');
        const belowImage = cardProduct.querySelector('.below-image');
        const titleEl = cardProduct.querySelector('.x-card-title');

        cardProduct.querySelectorAll('.label-container, .custom-label-container').forEach((container) => {
          if (container.closest('.below-image') || container.closest('.bottom-card') || container.closest('.next-price')) {
            container.removeAttribute('aria-hidden');
            return;
          }
          container.setAttribute('aria-hidden', 'true');
          if (mountEl && anchor && container.parentElement === mountEl) {
            mountEl.insertBefore(container, anchor);
          }
        });

        if (titleEl) {
          titleEl.removeAttribute('aria-label');
          titleEl.removeAttribute('aria-describedby');
        }

        if (belowImage && badgeItems.length > 0) {
          const group = document.createElement('div');
          group.className = 'x-card-badges-a11y';
          badgeItems.forEach((item) => {
            const line = document.createElement('p');
            line.className = 'x-card-badge-a11y-item sr-only m-0';
            line.textContent = item.text;
            group.appendChild(line);
          });
          belowImage.insertBefore(group, belowImage.firstChild);
        }
      },
      initAllLabels(el, productCard) {
          let productDatas = xParseJSON(el.getAttribute('x-labels-data'));
          let allLabels = document.getElementsByClassName('x-badges-block-data');

          if (!productDatas) return;

          if (productCard) {
            requestAnimationFrame(() => {
              if (Shopify.designMode || productCard) {
                const cardProduct = el.closest('.card-product');
                if (cardProduct) {
                  cardProduct.querySelectorAll('.x-card-badges-a11y').forEach((node) => node.remove());
                  let currentLabels = cardProduct.getElementsByClassName('x-badge-container');
                  while (currentLabels?.length > 0) {
                    currentLabels[0].remove();
                  }
                  cardProduct.querySelectorAll('.label-container, .custom-label-container').forEach((container) => {
                    if (container.closest('.below-image') || container.closest('.bottom-card') || container.closest('.next-price')) {
                      return;
                    }
                    container.remove();
                  });
                }
              }

              let variantId = null;
              const variantEl = el.closest('.card-product')?.querySelector(".current-variant");

              if (variantEl) {
                const currentVariant = JSON.parse(el.closest('.card-product')?.querySelector(".current-variant")?.textContent);
                variantId = (typeof currentVariant === 'object') ? currentVariant.id : currentVariant;
              }
              
              if (variantId) {
                productDatas.forEach(productData => {
                  if (productData.variant_id === Number(variantId)) {
                    for (let i = 0;i < allLabels.length;i++) {
                      let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                      if (!label.enable && !productData.isXBadgesPreview) continue;
                      
                      label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                      this.appendLabel(el, label, productData);
                    }  
                  }
                });    
              } else {
                for (let i = 0;i < allLabels.length;i++) {
                  let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                  if (!label.enable && !productDatas[0].isXBadgesPreview) continue;
                  
                  label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                  this.appendLabel(el, label, productDatas[0]);
                }  
              }

              const cardProduct = el.closest('.card-product');
              if (cardProduct) {
                const badgeItems = this.collectCardBadgeItems(cardProduct);
                this.finalizeCardBadgeAccessibility(cardProduct, badgeItems);
              }
            });
          } else {
            for (let i = 0;i < allLabels.length;i++) {
              let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
              if (!label.enable && !productDatas.isXBadgesPreview) return;
              
              label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
              this.appendLabel(el, label, productDatas);
            }  

            el.removeAttribute('x-labels-data');
          }
      },
      appendLabel(el, label, productData) {
        let template = this.processTemplate(el, label, productData);
        if (!template) return;

        if (productData.container == 'product-info') {
          el.innerHTML += template;
          return;
        }

        let mountEl = el;
        if (productData.container === 'card') {
          if (label.settings.position === 'custom' || this.isCardFixedOverlayPosition(label.settings.position)) {
            mountEl = this.getCardBadgeMountEl(el);
          }
        }

        if (label.settings.position == 'custom') {
          let container = mountEl.querySelector(`.custom-label-container`);
          if (!container) {
            container = document.createElement("div");
            let HTMLClass = `custom-label-container pointer-events-none`;
            if (productData.container === 'card') {
              HTMLClass += ' z-20';
            }
            container.setAttribute('class', HTMLClass);
            this.insertCardBadgeContainer(mountEl, container, productData);
          }
          container.innerHTML += template;
          return;
        }

        let container = mountEl.querySelector(`.${label.settings.position}-container`);
        if (!container) {
          container = this.createFixedPositionContainer(label.settings.position, productData, label);
          this.insertCardBadgeContainer(mountEl, container, productData);
        }

        container.innerHTML += template;
      },
      insertCardBadgeContainer(mountEl, container, productData) {
        if (productData.container !== 'card') {
          mountEl.appendChild(container);
          return;
        }
        const anchor = mountEl.querySelector('a.link-product-variant, a.x-labels-data, a');
        if (anchor) {
          mountEl.insertBefore(container, anchor);
        } else {
          mountEl.insertBefore(container, mountEl.firstChild);
        }
      },
      createFixedPositionContainer(position, productData = {}, label = null) {
        let HTMLClass = '';

        const isSpecialLabel = label && (label.type === 'custom-product-tag' || label.type === 'variant-metafield-label');
        if (productData.container == 'product-info' && !isSpecialLabel) {
          HTMLClass = `${position}-container font-heading label-container flex gap-1 flex-wrap`;
        }else{
          HTMLClass = `${position}-container font-heading label-container flex absolute gap-1 space-y-1`;
          HTMLClass += position.includes('top') ? ' top-3 flex-col' : ' bottom-3 flex-col';
          HTMLClass += position.includes('left') ? ' items-start left-3' : ' items-end right-3';
          if (productData.container === 'card') {
            HTMLClass += ' z-20';
          }
        }

        container = document.createElement("div");
        container.setAttribute('class', HTMLClass);
        return container;
      },
      processContent(el, label, productData) {
        let content = false;
        const canShow = this.canShow(label, productData);

        if (label.settings.image && canShow) {
          /** image label */
          let imageHeight, imageWidth;
          if (productData.container == 'product-info') {
            imageHeight = 126;
            imageWidth = Math.round(imageHeight * label.settings.image_aspect_ratio);
          } else {
            imageWidth = label.settings.size_mobile > label.settings.size ? label.settings.size_mobile * 15 : label.settings.size * 15;
            imageHeight = imageWidth / label.settings.image_aspect_ratio;
          }
          let image;
          if (label.settings.image.src) {
            image = label.settings.image.src.includes('burst.shopifycdn.com') ? label.settings.image.src : 
            label.settings.image.src + `&width=` + (imageWidth * 3);
          } else {
            image = label.settings.image.includes('burst.shopifycdn.com') ? label.settings.image : 
            label.settings.image + `&width=` + (imageWidth * 3);
          }
          if (productData.container == "card") {
            var imageDirection = label.settings.position.includes('left') ? "justify-start" : "justify-end";
            var styleImage = 'width: var(--width-image-label); height: var(--height-image-label)';
          } else {
            var imageDirection = productData.make_content_center ? "justify-center" : "justify-start";
            var styleImage = '';
          }
          content = `<div x-ref="content" class='x-badge-content w-fit flex ${imageDirection}{css-opacity}'>
            <img 
              loading="lazy"
              width="` + imageWidth + `"
              height="` + imageHeight + `"
              alt="` + (label.settings.image_alt.length > 0 ? label.settings.image_alt : productData.title) + `"
              src="` + image + `"
              style="${styleImage}"
            />
          </div>`;
        } else if ((label.settings.content || label.type == 'variant-metafield-label' || label.type === 'custom-product-tag') && canShow) {
          /** text label */
          let qty = (productData.inventory_management.length < 1 || productData.qty < 0) ? '' : productData.qty;
          let saleAmount = productData.sale_amount.includes('-') ? '' : productData.sale_amount;
          let countDown = label.settings.schedule_enabled ? '<span x-intersect.once="$nextTick(() => { if (typeof rePosition !== `undefined`) {rePosition()} });" class="x-badge-countdown-' + label.id + ' label-countdown empty:hidden"></span>' : '';
          let sale = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
          sale = sale == 100 ? 99 : sale;
          sale = sale > 0 ? sale + '%' : '';

          content = (label.settings.content || '').replace(/{sale}/gi, sale)
                      .replace(/{sale_amount}/gi, saleAmount)
                      .replace(/{qty}/gi, qty)
                      .replace(/{price}/gi, productData.price_with_currency)
                      .replace(/{count_down}/gi, countDown);
          
          const sizeClass = productData.container == 'product-info' ? '' : ` py-[3px] pl-3.5 pr-3.5`;
          const cardLabelClass = productData.container == 'product-info' ? 'font-medium md:leading-none leading-[14px] md:text-[12px] text-[9px] tracking-[1px]' : `font-bold leading-[14px] tracking-[0.9px] text-[9px] `;
          const inlineStyle = productData.container == 'product-info' ? '' : `style="font-size: var(--font-size-scale);"`;
          const inlineStyleIcon = productData.container == 'product-info' ? '' : `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;



          if (productData.metafield_label) {
            Object.entries(productData.metafield_label).forEach(([key, value]) => {
              content = content.replace(`{${key}}`, value);
            });
          }



          if (label.type == 'variant-metafield-label' && productData.variant_tags && productData.variant_tags.length) {
            let tagsHtml = '';
            productData.variant_tags.forEach((tag, index) => {
              let tagContent = tag;
              if (label.settings.add_prefix && content) {
                tagContent = content + ' ' + tagContent;
              }
              tagsHtml += this.generateBadgeHTML(el, label, productData, tagContent, sizeClass, inlineStyle, inlineStyleIcon, cardLabelClass, '{css-opacity}', '{css-type}');
            });
            return '<div class="flex flex-wrap gap-1">' + tagsHtml + '</div>';
          } else if (label.type === 'custom-product-tag') {
            if (!canShow) return false;
            const prefix = label.settings.prefix || '__label';
            
            // Fallback for preview if product_tags is missing
            if (productData.isXBadgesPreview && (!productData.product_tags || productData.product_tags.length === 0)) {
               productData.product_tags = ["__label: New product", "__label: Test 1", "__label: Test 2"];
            }



            const matchedTags = productData.product_tags ? productData.product_tags.filter(tag => tag && tag.startsWith(prefix)) : [];


            let tagsHtml = '';

            matchedTags.sort().forEach(tag => {
               // Logic: remove prefix, trim, handle colon
               let displayContent = tag.substring(prefix.length).trim();
               if (displayContent.startsWith(':')) {
                 displayContent = displayContent.substring(1).trim();
               }

               if (displayContent) {
                  tagsHtml += this.generateBadgeHTML(el, label, productData, displayContent, sizeClass, inlineStyle, inlineStyleIcon, cardLabelClass, '{css-opacity}', '{css-type}');
               }
            });
            
            if (tagsHtml === '') {

                return false;
            }
            return '<div class="flex flex-wrap gap-1">' + tagsHtml + '</div>';
          }

          content = content.length > 0 ? this.generateBadgeHTML(el, label, productData, content, sizeClass, inlineStyle, inlineStyleIcon, cardLabelClass, '{css-opacity}', '{css-type}') : false;

          if (countDown.length > 0 && label.settings.schedule_enabled) {
            Alpine.store('xHelper').countdown(label.settings, function(canShow, seconds, minutes, hours, days) {
              let container;
              if (productData.container === "card") {
                container = el.container ? el.container : el;
                if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
                  container = el.closest('.card-product')
                }
              } else {
                if (label.settings.position == "next-price") {
                  container = document.querySelector(productData.teleport_dest_price);
                } else if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
                  container = el.container ? el.container : el;
                } else {
                  container = document.querySelector(productData.teleport_dest_image);
                }
              }

              const countdownElements = container?.getElementsByClassName('x-badge-countdown-' + label.id);
              if (!canShow) {
                for (let i = 0;i < countdownElements?.length;i++) {
                  countdownElements[i].innerHTML = '';
                }
                return;
              }
              days = days > 0 ? days + "D&nbsp;&nbsp;&nbsp;" : "";
              hours = hours == 0 && days.length == 0 ? "" : hours + " : ";
              const timeLeft = days + hours + minutes + " : " + seconds;
              for (let i = 0;i < countdownElements?.length;i++) {
                countdownElements[i].innerHTML = timeLeft;
              }
            });
          }
        }
        return content;
      },
      processTemplate(el, label, productData) {
        let template = '';
        let teleportTemplateOpen = '';
        let teleportTemplateClose = '';
        if (content = this.processContent(el, label, productData)) {
          const cssOpacity = " opacity-" + label.settings.opacity;
          let cssPosition = ''
          let containerCssClass = ''

          if (productData.container == "product-info" && label.settings.position == "custom" && productData.position_adapt) {
            cssPosition = "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-" + label.settings.horizontal_position+"%, -" + label.settings.vertical_position+"%);" + " top: " + (label.settings.vertical_position) + "%;";
          } else {
            cssPosition = productData.container == "card" ? "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-"+ label.settings.horizontal_position+"%, -"+ label.settings.vertical_position+"%);"
            + " top: " + (label.settings.vertical_position) + "%;"
            : "";
          }
          let cssType = '';
          if (label.settings.type == 'round') cssType = ' rounded-[3px]';
          if (label.settings.type == 'rounded-full') cssType = ' rounded-full';

          if (productData.container === "card") {
            containerCssClass = " absolute w-max";
          } else if (productData.position_adapt) {
            containerCssClass = (label.settings.position === "custom") ? " absolute w-max h-fit product-info-custom-label" : " w-fit h-fit product-info-custom-label";
          }

          if (productData.container == "product-info" && productData.position_adapt) {
            if (productData.teleport_dest_price || productData.teleport_dest_image) {
              teleportTemplateClose = "</template>"
            }
            if (label.settings.position == "next-price") {
              if (productData.teleport_dest_price) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_price}">`;
              }
            } else if (label.settings.position == "custom") {
              if (productData.teleport_dest_image) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_image}">`
              }
            } else if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
              teleportTemplateOpen = "";
              teleportTemplateClose = "";
            } else {
              const imageContainer = document.querySelector(productData.teleport_dest_image);
              let container = imageContainer.querySelector(`.${label.settings.position}-container`);
              if (!container) {
                container = this.createFixedPositionContainer(label.settings.position, productData);
                imageContainer.appendChild(container);
              }
              if (productData.teleport_dest_image) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_image} .${label.settings.position}-container">`
              }
            }
          }

          containerCssClass += label.settings.horizontal_position > 50 ? " text-end" : " text-start";
          const previewShowCondition = productData.isXBadgesPreview ? `x-show="$store.xBadges.previewActiveBlock == '{label-id}'"` : '';
          let imgClass;
          if (productData.container == "product-info" && (label.settings.position == "below-image" || label.settings.position == "bottom-card" || !productData.position_adapt)) {
            let imageContainerAlignment = productData.make_content_center ? 'flex justify-center' : ''
            imgClass = label.settings.image ? ` label-img ${imageContainerAlignment}` : '';
          } else {
            imgClass = label.settings.image ? ' label-img' : '';
          }

          template = this.getLableTemplate(productData.container, label.settings.position);
          template = template.replace('{preview-show-condition}', previewShowCondition)
            .replace('{content}', content)
            .replace(/{css-opacity}/g, cssOpacity)
            .replace('{css-position}', cssPosition)
            .replace(/{css-type}/g, cssType)
            .replace('{container-css-class}', containerCssClass)
            .replace('{container-img-class}', imgClass)
            .replace('{teleport-template-open}', teleportTemplateOpen)
            .replace('{teleport-template-close}', teleportTemplateClose)
            .replace(/{label-id}/gi, label.id);
        }
        return template;
      },
      generateBadgeHTML(el, label, productData, content, sizeClass, inlineStyle, inlineStyleIcon, cardLabelClass, cssOpacity, cssType) {
        const cardA11yClass = productData.container === 'card' ? '' : ' select-none';
        return `<div
                x-ref="content"
                class='x-badge-content ltr x-badge-text${cardA11yClass} inline-flex justify-center${sizeClass} items-center{css-opacity}{css-type} gap-2'
                ${inlineStyle}
              ><span class="icon-label empty:hidden" ${inlineStyleIcon} aria-hidden="true">${label.settings.icon}</span><span class="${cardLabelClass} font-heading  p-break-words uppercase w-fit">${content}</span></div>`;
      },
      getLableTemplate(container, position) {
        if (container == 'product-info') {
          return this.productDetailTemplate;
        } else if (position == 'custom') {
          return this.customPositionTemplate;
        } else if (position == 'below-image' || position == 'bottom-card' || position == 'next-price') {
          return this.outSideImageTemplate.replace('{queryEL}', position);
        }

        return this.fixedPositionTemplate;
      },
      canShow(label, productData) {
        if (productData.isXBadgesPreview) {
          return true;
        }

        if (productData.container == 'card' && !label.settings.show_on_product_card) {
          return false;
        }

        if (productData.container == 'product-info' && !label.settings.show_on_product_page) {
          return false;
        }

        if (label.type == "sale-label" && productData.compare_at_price > productData.price) {
          return true;
        }

        if (label.type == "sold-out-label" && !productData.available) {
          return true;
        }
        if (label.type == "preorder-label" ) {
          if (productData.can_show_preorder && productData.available) {
            return true;
          } else {
            return false;
          }
        }
        if (label.type == "new-label" ) {
          if (label.settings.day_since == 'creation_date' && label.settings.number_show < productData.diff_day_create) {
            return false;
          } else if (label.settings.day_since == 'activation_date' && label.settings.number_show < productData.diff_day_publish) {
            return false;
          }
        }
        if (label.type == "variant-metafield-label") {
          return !!(productData.variant_tags && productData.variant_tags.length > 0);
        }

        if (label.type == 'custom-product-tag') {
          const prefix = label.settings.prefix || '__label';
          const tags = productData.product_tags || [];
          
          if (productData.isXBadgesPreview && (!tags || tags.length === 0)) {
             return true; 
          }

          const hasMatch = tags.some(tag => tag && tag.startsWith(prefix));
          return hasMatch;
        }

        if (label.settings.schedule_enabled) {
          let endDate = new Date(
            label.settings.end_year,
            label.settings.end_month - 1,
            label.settings.end_day,
            label.settings.end_hour,
            label.settings.end_minute
          );
          label.endTime = endDate.getTime()
            + (-1 * label.settings.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
  
          let startDate = new Date(
            label.settings.start_year,
            label.settings.start_month - 1,
            label.settings.start_day,
            label.settings.start_hour,
            label.settings.start_minute
          );
          label.startTime = startDate.getTime()
            + (-1 * label.settings.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;

          let now = new Date().getTime();
          if (label.endTime < now) {
            return false;
          }

          if (label.startTime > now) {
            return false;
          }
        }
        
        if (label.settings.applied_products.includes(productData.product_id)) {
          return true;
        }

        for(let i=0;i<label.settings.applied_collections.length;i++) {
          if (productData.collections.includes(label.settings.applied_collections[i])) {
            return true;
          }
        }

        if (label.type != "sale-label"
          && label.type != "sold-out-label"
          && label.settings.applied_products.length == 0
          && label.settings.applied_collections.length == 0) {
          return true;
        }

        return false;
      }
    });
  });
});
